// Auto-refactored from translations.js on 2026-08-19
// Locale: tr

const tr = {
  wieMoeglich: { question: 'Bu nasıl mümkün?', answer: 'Değer zincirini yeniden düşündük.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK Yolu',
    fazit: 'Kısaltılmış tedarik zinciri en büyük maliyet kalemlerini ortadan kaldırır.',
    fazitBigPre: 'Bu, şu orana kadar indirim sağlar:',
    fazitBigValue: '80%',
    steps: [ 'Maden', 'Kesim atölyesi', 'Sertifikasyon', 'Son müşteri' ]
  },
  nav: { language: 'Dil', contact: 'İletişim' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Eşsiz bir fırsat',
    subtitle: 'Gelecek odaklı varlık oluşturun.',
    description: 'STIG ROCK, insanlara doğal pırlantalar, sürdürülebilir varlık oluşturma ve eşsiz bir topluluğa erişim sunan uluslararası bir platformdur.',
    scroll: 'Keşfetmek için kaydırın'
  },
  disclaimer: {
    overline: 'Yasal Uyarı',
    title: 'Disclaimer',
    paragraphs: [
      'Bu sunum yalnızca bilgilendirme amaçlıdır ve finansal, yatırım veya vergi danışmanlığı teşkil etmez.',
      'STIG ROCK bir finansal ürün değildir; maddi varlık olarak doğal pırlantalarla ilgilidir.',
      'Değer artışları, kârlar veya getiriler için herhangi bir garanti verilmez. Geçmişteki gelişmeler, gelecekteki sonuçların bir göstergesi değildir.',
      'Komisyonlarla bağlantılı olarak sunulan tüm hesaplamalar yalnızca örnek niteliğindedir ve herhangi bir garanti teşkil etmez.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'YAPI', 'ÜZERİNE KURULU' ],
    body: 'STIG Group, açıklık, sorumluluk ve uzun vadeli değer üzerine kurulu uluslararası bir gruptur. Her marka, her girişim ve her iş ortaklığı tek bir standardı izler — kısayol yok, istisna yok.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'YAPI', 'ÜZERİNE KURULU' ],
        body: 'STIG Group, açıklık, sorumluluk ve uzun vadeli değer üzerine kurulu uluslararası bir gruptur. Her marka, her girişim ve her iş ortaklığı tek bir standardı izler — kısayol yok, istisna yok.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'ÖZEL ELMASLARIN', 'DÜNYASI' ],
        body: 'STIG ROCK, yüksek kaliteli GIA sertifikalı pırlantaları şeffaf yapılar ve seçkin bir müşteri deneyimiyle birleştiren modern bir STIG Group konseptidir. Net çözüm planları, profesyonel süreç yönetimi ve uluslararası odak.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'ULUSLARARASI', 'ELMAS TİCARETİ' ],
        body: "STIG International, STIG Group'un bir parçasıdır ve GIA sertifikalı pırlantaların uluslararası ticareti konusunda uzmanlaşmıştır. Küresel ortaklıklarla kalite, güven ve modern ticaret yapılarına odaklanır."
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'MADENDEN İTİBAREN', 'SORUMLULUK' ],
        body: 'Ethical Mines, sorumlu madencilik, izlenebilir köken ve çatışmasız pırlantalar demektir. Madenden pazara — şeffaflık, dürüstlük ve tüm tedarik zinciri boyunca uzun vadeli sorumluluk için eksiksiz belgelendirme.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Pırlantalar',
    stigDrawback: 'Gerçek değer saklama aracı',
    overline: 'Olanaklar',
    title: 'Varlık oluşturma olanakları',
    subtitle: 'Karşılaştırmalı geleneksel yollar.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex veya Kripto',
        drawback: 'yüksek derecede spekülatif, öngörülemez, karmaşık'
      },
      {
        tag: 'Hisseler',
        name: 'Borsa İşlemleri',
        drawback: 'dalgalanma riski, gerekli bilgi, zaman maliyeti'
      },
      {
        tag: 'Kripto',
        name: 'Ticaret',
        drawback: 'oynaklık, düzenleme riski, güvenlik açıkları'
      }
    ]
  },
  chance: {
    overline: 'Pırlantalar',
    title: 'Küçümsenen fırsat',
    body: 'Pırlantalar yıllardır en istikrarlı ve fırsatlarla dolu yatırım araçlarından biri olmuştur, ancak şimdiye kadar sadece az sayıda kişi bu potansiyelden yararlanmıştır.',
    callout: 'STIG ROCK ile ilk kez herkesin bu olağanüstü olanaklara erişmesini sağlıyoruz.'
  },
  wertentwicklung: {
    overline: 'Değer Gelişimi 1995 — 2025',
    title: 'Değerin hikayesi.',
    usd: 'ABD Doları',
    usdValue: '-49%',
    diamond: 'Pırlantalar',
    diamondValue: '+185%',
    note: '1995 — 2025 arası gelişim'
  },
  hauptgruende: {
    overline: 'Temel Nedenler',
    title: 'Pırlantalar için altı neden',
    lead: 'Pırlantalar, para birimlerinden ve finansal sistemlerden bağımsız olarak varlığını sürdüren ve yüzyıllardır değerini koruyan gerçek maddi varlıklardır.',
    items: [
      {
        n: '01',
        title: 'Krizlere karşı güvenli değer istikrarı',
        body: 'Maddi varlık garantisi. Para birimlerinden ve finansal sistemlerden bağımsız.'
      },
      { n: '02', title: 'Nihai hareketlilik', body: 'Küçük, gizlemesi ve taşıması kolay.' },
      {
        n: '03',
        title: 'Çeşitlendirme ve kıtlık',
        body: 'Arz darboğazları ve doğal sınırlama.'
      },
      { n: '04', title: 'Uzun vadeli büyüme', body: "1995'tan beri +185%." },
      {
        n: '05',
        title: 'Şeffaflık ve ayrıcalık',
        body: 'Garanti olarak 4C: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Kraliyet ailelerinin rezervi',
        body: 'Kraliyet aileleri bile pırlantaları varlık rezervi olarak kullanır.'
      }
    ]
  },
  markt: {
    overline: 'Pazar Hacmi',
    title: '99 — 108 Milyar USD',
    sub: '2025 yılındaki işlem hacmi',
    unit: 'Milyar USD',
    forecast: '2032 / 2034 yılına kadar öngörü: ılımlı büyüme ile yaklaşık 140 – 168 milyar USD (yıllık ~%4 – 5).',
    source: 'Kaynak: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — İnovasyon',
    title: 'Bir yenilik. Dünyada bir ilk.',
    body: 'STIG ROCK, insanların pırlanta piyasasında değer artışına ek olarak pasif gelir elde etmelerini sağlayan dünyadaki ilk platformdur.',
    leadershipTag: 'Liderlik · İletişim',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, BAE',
      'Sicil No. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Şirket Hakkında',
    titleLines: [ 'ULUSLARARASI', 'YAPI', 'NET VİZYON' ],
    body: 'STIG ROCK; güven, güvenlik ve uzun vadeli yapıya odaklanarak pırlanta piyasasını daha şeffaf, modern ve müşteri odaklı hale getirmek için kuruldu.'
  },
  dualTimeline: {
    overline: 'DUAL SİSTEM · GÖRSEL',
    title: 'Bir alım, iki yol.',
    intro: 'Pırlantanız güvende — ikinci bir kurumsal pırlanta ise çalışıyor.\n' +
      'Yılda dört ticaret döngüsü, pırlantanız asla ticarete konu olmadan indirimi üretir.',
    customer: {
      kicker: 'TIMELINE 1',
      title: 'STIG ROCK\nMüşteri',
      sub: 'Ham üründen teslimata',
      purchase: 'Alım',
      cut: 'Kesim',
      certify: 'Sertifika',
      delivery: 'Teslimat'
    },
    stig: {
      kicker: 'TIMELINE 2',
      sub: 'İkinci bir kurumsal pırlanta · dört döngü · aktif ticaret',
      cycleSteps: [ 'Alım', 'Planlama', 'Kesim', 'Satış' ],
      footerCycle: '4 × Alım-Kesim-Satış',
      footerDiscount: 'İndirim → Müşteri'
    },
    summary: {
      stored: 'Pırlanta güvenle saklanır',
      cycles: 'Yıllık ticaret döngüsü',
      months: 'Ay süre'
    }
  },
  kimberleySlide: {
    overline: 'Kimberley Süreci',
    title: 'Yalnızca çatışmasız pırlantalarla çalışıyoruz.',
    body: "Kimberley Process, çatışma pırlantalarının ticaretini engelleyen uluslararası bir sertifikasyon sistemidir. STIG ROCK'un her taşı eksiksiz izlenebilir ve sorumlu şekilde sertifikalandırılmış kaynaklardan gelir.",
    sealAlt: 'Kimberley Process — Resmi Mühür'
  },
  zertifiziert: {
    overline: 'GIA · Sertifikasyon',
    title: 'Sertifikalı ve şeffaf',
    body: 'Her pırlanta en yüksek kalite standartlarını karşılar ve saygın kuruluşlar tarafından incelenip sertifikalandırılır. Her taş benzersizdir ve bireysel bir sertifika alır.',
    kimberley: 'Kimberley Process — yalnızca çatışmasız pırlantalarla çalışıyoruz.'
  },
  sicherheit: {
    overline: 'Kalite & Güvenlik',
    title: 'Gemological Institute of America',
    headline: 'Pırlantalarınız için sertifikalı uzmanlık.',
    p1: 'GIA, Gemological Institute of America (Amerika Gemoloji Enstitüsü) anlamına gelir — küresel 4C standardının (Carat, Clarity, Color, Cut) yaratıcısı ve dünyanın önde gelen bağımsız, kâr amacı gütmeyen pırlanta değerlendirme enstitüsüdür.',
    p2: 'Bir GIA sertifikası bir pırlantanın gerçekliğini ve doğallığını, ayrıca tüm kalite özelliklerinin nesnel ve tarafsız bir belgelendirmesini garanti eder.',
    p3: 'Müşteri açısından bu, en yüksek güvenlik ve güven demektir: ne satın aldığını tam olarak bilir, kalitesine uygun adil bir fiyat öder ve dünya çapında kabul gören, değeri korunan, her zaman yeniden satılabilen bir pırlantaya sahip olur.',
    body: 'Pırlantalarınız için sertifikalı uzmanlık. GIA her taşı yüksek hassasiyet ve uzun yıllara dayanan deneyimle değerlendiriyor — şirketimiz ve müşterilerimiz için güvenilir değerleme raporları.',
    transparency: 'Her pırlanta en yüksek kalite standartlarını karşılar, saygın kuruluşlar tarafından kontrol edilir ve sertifikalandırılır. Her taş eşsizdir ve bireysel bir sertifika alır.',
    kimberley: 'Kimberley Process — yalnızca çatışmasız pırlantalarla çalışıyoruz.'
  },
  plaene: {
    overline: 'Solution Planları (SP)',
    title: 'Eşsiz bir ürün inovasyonu',
    sub: "Altı kademeli Solution Planları — 1.000$'dan 100.000$+ üzerine kadar, her biri ayda ve tüm süre boyunca artan indirimlerle.",
    recommended: 'Popüler',
    oneYear: '1 Yıl',
    rowLabels: {
      delivery: 'Teslimat süresi',
      price: 'Ürün Fiyatı',
      carat: 'Karat',
      monthly: 'İndirim (Aylık)',
      totalDiscount: 'İndirim (Toplam)',
      duration: 'Süre'
    },
    headers: {
      plan: 'Plan',
      from: 'İtibaren',
      carat: 'Karat',
      monthly: 'İndirim / Ay',
      total: 'Toplam İndirim',
      duration: 'Süre'
    },
    duration: '1 Yıl',
    footnote: 'Tüm fiyat bilgileri bağlayıcı değildir; kalite, talep ve güncel piyasa gelişimine bağlıdır. Solution Planları 2 yıl için de mümkündür.'
  },
  plaeneVIP: {
    overline: 'Solution Planları + VIP Paketi',
    title: 'VIP Paketi ile daha da fazla indirim',
    sub: "Yedi Solution Planı — $250'dan $100K+'ye kadar,\n" +
      'her biri aylık ve tüm süre boyunca artan indirimlerle.',
    rowLabels: {
      delivery: 'Teslimat süresi',
      price: 'Ürün Fiyatı',
      carat: 'Karat',
      monthly: 'İndirim (Aylık)',
      totalDiscount: 'İndirim (Toplam)',
      vip1: 'VIP Paketi 1 (+%1)',
      vip2: 'VIP Paketi 2 (+%2)',
      vip3: 'VIP Paketi 3 (+%3)'
    },
    footnote: 'Tüm fiyat bilgileri bağlayıcı değildir; kalite, talep ve güncel piyasa gelişimine bağlıdır.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Olanakların',
    sub: 'Solution Planınız sona erdikten sonra pırlanta(lar)ınızı evinize teslim ettirebilir ya da tekrar satabilirsiniz.',
    options: [
      { key: 'deliver', title: 'Teslim al', body: 'DS Planı* fiyatına pırlantalar (Karat)' },
      {
        key: 'sellToUs',
        title: 'Bize sat',
        body: 'Pırlantalarınızı ödediğiniz satın alma fiyatı üzerinden bize geri satabilirsiniz.'
      },
      {
        key: 'sellThirdParty',
        title: 'Üçüncü şahıslara sat',
        body: 'Pırlantalarınızı üçüncü şahıslara yeniden satabilirsiniz.'
      },
      {
        key: 'offer',
        title: 'Otomatik satın alma teklifi',
        body: 'Teslimattan 4 hafta önce satın alma teklifi — Solution Planı sona ermeden otomatik olarak görünür!'
      }
    ],
    footnote: '*DS Planı, Solution Planı anlamına gelir.'
  },
  tradWeg: {
    overline: 'Geleneksel Ticaret',
    title: 'Geleneksel yol',
    sub: 'Bir pırlanta son müşteriye ulaşmadan önce, madenden çıkan ham elmas fiyatına kıyasla aracı, toptan ve perakende ticaret nedeniyle önemli kar marjları oluşur.',
    steps: [
      { title: 'Maden', subtitle: 'Ham Elmaslar' },
      { title: 'Aracı Satıcı', subtitle: 'Ham Elmas Alımı' },
      { title: 'Kesim Atölyesi', subtitle: 'Mücevher Pırlanta Kesimi' },
      { title: 'Sertifikalandırma', subtitle: 'GIA gibi tanınmış enstitülerce' },
      { title: 'Pırlanta Borsası', subtitle: 'Toptancıya Satış' },
      { title: 'Toptan Ticaret', subtitle: 'Perakendeciye Satış' },
      { title: 'Perakende Ticaret', subtitle: 'Örn. Kuyumcular' },
      { title: 'Son Müşteriler', subtitle: 'Pırlanta Alımı' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK yolu',
    sub: 'Ham elmasları doğrudan madenden satın alarak, ortaklarımız aracılığıyla kestirip sertifikalandırarak bu döngüyü kırıyoruz. Böylece bu kar marjlarını indirim kredisi şeklinde müşterilerimize yansıtabiliyoruz.',
    duration: '12 Ay – DS Planı Süresi',
    centerBig: '04',
    centerCaption: 'DS Planı süresi boyunca en fazla 4 ticaret döngüsü',
    cycle: [
      { n: '1.', title: 'Ham elmas alımı', body: 'bir DS Planı için' },
      { n: '2.', title: 'Kesim ve sertifikalandırma', body: 'ortaklarımız aracılığıyla' },
      { n: '3.', title: 'Son müşterilere satış', body: 've toptancılara' },
      { n: '4.', title: 'Bu işlemi tekrarlıyoruz', body: 'yılda 4 defaya kadar' },
      {
        n: '5.',
        title: 'Ek gelirler',
        body: 'Kârlar maden lisanslarına, ham elmas çıkarımına ve geri alıma akıyor – STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Maden', subtitle: 'Ham Elmaslar' },
      { title: 'Kesim Atölyesi', subtitle: 'Ortaklarımız aracılığıyla' },
      { title: 'Sertifikalandırma', subtitle: 'Tanınmış enstitülerce' },
      { title: 'Son Müşteriler', subtitle: 'Satın Alma & İndirim Kredileri' }
    ],
    footnote: '*DS Planı, Solution Planı anlamına gelir.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP Paketleri',
    sub: "İmzaladığınız tüm Solution Planları için 12 ay boyunca geçerlidir. VIP paketine bağlı olarak: +%1'den +%3'e kadar ek indirim",
    cardKicker: 'ek olarak – tüm',
    cardKicker2: 'Solution Planları için',
    tip: 'Öneri: 2.800$ yatırım hacminden itibaren en çok VIP Paketi 3 kazandırır.',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'İndirimler tasarrufa dönüşür',
      body: 'Aylık yük yerine aylık tasarruf. İndirimlerden tasarruf doğar – ve bunlar tam da her ay kendi cebinizden ödediğiniz şeyleri karşılar.',
      line1Label: 'DS Planı başlangıcı',
      line1Value: '$5.000',
      line2Label: 'aylık indirim',
      line2Value: '3%',
      line3Label: 'VIP Paketi 3',
      line3Value: '+3%',
      resultLabel: 'aylık tasarruf',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Bu nasıl mümkün?',
    title: 'Değer zincirini yeniden düşündük.',
    traditionalTitle: 'Geleneksel yol',
    totalLabel: 'Son müşteri fiyatı',
    traditionalSteps: [
      'Maden — Ham Elmaslar',
      'Aracı Satıcı — Satın Alma',
      'Kesim Atölyesi — Kesim',
      'Sertifikalandırma (GIA)',
      'Pırlanta Borsası — Toptan Ticaret',
      'Toptan Ticaret → Perakende Ticaret',
      'Kuyumcular → Son Müşteri'
    ],
    traditionalNote: 'Bir pırlanta son müşteriye ulaşmadan önce, aracı, toptan ve perakende ticaret nedeniyle önemli kar marjları oluşur.',
    stigTitle: 'STIG ROCK yolu',
    stigSteps: [
      'Doğrudan Alım — Madenden Ham Elmaslar',
      'Ortaklarımızla Kesim & Sertifikalandırma',
      'Son Müşterilere & B2B Müşterilerine Satış',
      'Yılda en fazla 4 ticaret döngüsü'
    ],
    stigNote: 'Döngüyü kırıyoruz ve kar marjlarını indirim kredisi olarak müşterilerimize yansıtıyoruz — DS Planı süresi boyunca 4 ticaret döngüsüne kadar.'
  },
  optionen: {
    overline: 'Olanakların',
    title: 'Solution Planınız sona erdiğinde',
    items: [
      { title: 'Teslim al', body: 'DS Planı fiyatına pırlantalar (Karat).' },
      { title: 'Bize sat', body: 'Ödediğiniz satın alma fiyatı üzerinden geri satış.' },
      { title: 'Üçüncü şahıslara sat', body: 'Pırlantaları serbest piyasada satmak.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Planları — eşsiz bir ürün inovasyonu',
    title: 'Kolay yol',
    caption: '3 · Adım · Başarıya',
    captionParts: { count: '3', middle: 'Adım', end: 'Başarıya' },
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Kayıt',
        body: 'Sizi tavsiye eden kişiyle iletişime geçin ve ücretsiz bir hesap oluşturun!'
      },
      {
        n: '02',
        icon: 'cart',
        title: 'Ürün satın alımı',
        body: "250$'dan başlayan fiyatlarla"
      },
      {
        n: '03',
        icon: 'discount',
        title: 'İndirimleri al',
        body: 'Aylık indirim kredileri kazan.'
      }
    ]
  },
  business: {
    overline: 'Bonus Türleri',
    title: 'En kolay ve en adil yol.',
    sub: 'Beş bonus türü — başarılı iş kurulumun için.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: "Level 3'e kadar, Pearl / Ruby kariyer basamağından itibaren."
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: "Sapphire'den itibaren — sonsuz derinlikte."
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: "Infinity Bonus üzerinden – Level 5'e kadar · Kalifikasyon OLMADAN."
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: 'Dünya çapındaki cironun 3 havuzu.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Milyon',
        desc: 'Pırlanta (Karat) cinsinden tek seferlik bonus.'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Bu bonus, 3. seviyeye kadar yeni imzalanan her Solution Planı için size ödenir. Çok düşük kalifikasyonlarla seviyelerin kilidini açarsınız.',
    total: "18%'e kadar Unilevel Bonus",
    totalParts: { prefix: 'En fazla', big: '18%', suffix: 'Unilevel Bonus' },
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'başlangıçtan itibaren',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'Pearl kariyer basamağından itibaren',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'Ruby kariyer basamağından itibaren',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Sapphire kariyer basamağından itibaren Infinity Bonus planımız için kalifiye olursunuz. %3 bonus alırsınız. Her yeni kariyer basamağıyla birlikte ek yüzdeler eklenir. Ekibinizdeki bir iş ortağı da kalifiye olursa, rütbe rütbe aradaki farkı alırsınız.',
    exampleTitle: 'Örnek',
    exampleRows: [
      { label: 'Blue Diamond rütbesindesin', value: '12%' },
      { label: 'İş ortağın Sapphire rütbesinde', value: '3%' }
    ],
    exampleResult: { label: "Senin Infinity Bonus'un", value: '9%' },
    totalNote: "Ekibindeki tüm imzalanan Solution Planları üzerinden toplam %24'e kadar Infinity Bonus — sonsuz derinlikte.",
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: "Bu bonus ile ekibinizin başarısından yararlanırsınız. İş ortaklarınızın Infinity Bonus'u üzerinden %5 Matching Bonus alırsınız — ve bu ekibinizin 5. seviyesine kadar geçerlidir.",
    note: 'Ekibindeki tüm Infinity Bonus ödemeleri üzerinden – 5. seviyeye kadar. Başlangıçtan itibaren – Kalifikasyon OLMADAN.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Toplam',
    totalValue: "25%'e kadar",
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: "Dünya çapındaki cironun %3'ü eşit parçalar halinde 3 farklı havuza aktarılır. Belirli kariyer basamaklarına ulaşarak her bir havuz için kalifiye olursunuz.",
    forever: 'Bir kez ulaşıldığında – SONSUZA KADAR ortaklık!',
    pools: [
      { key: 'p1', label: 'Havuz 1', value: '1%', qual: "Blue Diamond'dan itibaren" },
      { key: 'p2', label: 'Havuz 2', value: '1%', qual: "Purple Diamond'dan itibaren" },
      {
        key: 'p3',
        label: 'Havuz 3',
        value: '1%',
        qual: "Double Diamond Elite'den itibaren"
      }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Toplam',
    totalValue: '3%',
    totalSuffix: 'dünya çapındaki cirodan'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Diamond kariyer basamağından itibaren bir Rang Bonus alırsınız. Bu, pırlanta (Karat) olarak ödenir. Bu tek seferlik bir bonustur.',
    highlight: 'Toplam değeri şu olan pırlantalar (Karat):',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Karrierestufen',
    sub: 'Kariyer basamaklarına ulaşmak için tarihsel toplam ciro (HG) dikkate alınır. Sapphire aşamasından itibaren bu cironun birden fazla ekibe dağıtılması gerekir. Ruby veya daha yüksek bir seviyeye ulaşmak için en az iki doğrudan iş ortağının bir Solution Planına sahip olması gerekir.',
    forever: 'Bir kez ulaşıldığında – SONSUZA KADAR onaylandı!',
    footnote: 'HV = Tarihsel Toplam Ciro. **Dağılım: bir ekibin HG içindeki azami payı.',
    distributionLabel: '**Dağılım:',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', dist: '', perks: [ '1 Unilevel' ] },
      {
        name: 'Pearl',
        coin: 'image83.png',
        hg: '250 HV',
        dist: '',
        perks: [ '2 Unilevel' ]
      },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        dist: '',
        perks: [ '2 doğrudan iş ortağı', '3 Unilevel' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        dist: '60%',
        perks: [ '3 Unilevel', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        dist: '60%',
        perks: [ '3 Unilevel', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        dist: '50%',
        perks: [ '3 Unilevel', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        dist: '50%',
        perks: [ '3 Unilevel', 'Infinity 12%', '$20k Bonus', '1 Havuz' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        dist: '40%',
        perks: [ '3 Unilevel', 'Infinity 15%', '$50k Bonus', '1 Havuz' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        dist: '40%',
        perks: [ '3 Unilevel', 'Infinity 18%', '$100k Bonus', '2 Havuz' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        dist: '30%',
        perks: [ '3 Unilevel', 'Infinity 21%', '$150k Bonus', '2 Havuz' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        dist: '30%',
        perks: [ '3 Unilevel', 'Infinity 22%', '$1M Bonus', '3 Havuz' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        dist: '25%',
        perks: [ '3 Unilevel', 'Infinity 23%', '$2M Bonus', '3 Havuz' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        dist: '20%',
        perks: [ '3 Unilevel', 'Infinity 24%', '$5M Bonus', '3 Havuz' ]
      }
    ]
  },
  cta: {
    overline: 'Bizimle harekete geç',
    title: 'Doğru zaman tam şu an.',
    body: 'Bu iş modeli yeni standartlar belirliyor ve uzun vadeli sürdürülebilir ve başarılı bir iş için tüm başarı faktörlerini birleştiriyor. Bugün kaydolun, Solution Planınızı seçin ve bu eşsiz iş fırsatını değerlendirin.',
    hint: 'Sizi bu sunuma davet eden kişiyle konuşun — sizin için bir kayıt bağlantısı var.',
    formName: 'İsim',
    formEmail: 'E-posta',
    formPhone: 'Telefon',
    formSubmit: 'İletişime geç',
    success: 'Teşekkürler — sizinle gizli ve kişisel olarak iletişime geçeceğiz.',
    callCta: 'Ara',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Yasal Uyarı & Disclaimer',
    disclaimer: 'Bu sunum yalnızca bilgilendirme amaçlıdır ve finansal, yatırım veya vergi danışmanlığı teşkil etmez. STIG ROCK bir finansal ürün değildir; maddi varlık olarak doğal pırlantalarla ilgilidir. Değer artışları, kârlar veya getiriler için herhangi bir garanti verilmez. Geçmişteki gelişmeler, gelecekteki sonuçların bir göstergesi değildir. Komisyonlarla bağlantılı olarak sunulan tüm hesaplamalar yalnızca örnek niteliğindedir ve herhangi bir garanti teşkil etmez. İçeriklerin değiştirilme hakkı saklıdır — serbest çeviri (resmi çeviri değildir).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, BAE',
    copy: '© 2026 STIG International. Tüm hakları saklıdır.',
    version: 'Sürüm: DS-12-2025 V3'
  },
  misc: { next: 'Sonraki Bölüm' }
};

export default tr;
